import { render } from "./SearchDetailWrapper.vue?vue&type=template&id=ab4da988"
import script from "./SearchDetailWrapper.vue?vue&type=script&lang=js"
export * from "./SearchDetailWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__